import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const services = [
  {
    title: "Strategic Consulting & Policy Advisory",
    description:
      "Support in strategic management, project design, and policy development, especially in the fields of environment, security, and migration.",
    image: "/services/Strategic Consulting & Policy Advisory.webp",
  },
  {
    title: "Crisis Response & Capacity Building",
    description:
      "Advisory and operational support to governments and organizations in times of war, humanitarian crises, or natural disasters.",
    image: "/services/Crisis Response & Capacity Building.webp",
  },
  {
    title: "Applied Research & Experimental Development",
    description:
      "Interdisciplinary projects in environmental sciences, biotechnology, agriculture, social sciences, and crisis studies.",
    image: "/services/Applied Research & Experimental Development.webp",
  },
  {
    title: "Education & Training",
    description:
      "Professional seminars, workshops, and tailored training for institutions, organizations, and communities.",
    image: "/services/Education & Training.webp",
  },
  {
    title: "Publications & Knowledge Sharing",
    description:
      "Scientific reports, policy briefs, and dissemination activities, including conferences and cultural events.",
    image: "/services/Publications & Knowledge Sharing.webp",
  },
];

export default function Services() {
  return (
    <div className="pt-24 pb-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            Our Services
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            A comprehensive portfolio designed to link research, training, and
            strategic consulting for maximum impact.
          </p>
        </div>
        <div className="mb-20">
          <div className="relative w-full h-96 rounded-3xl overflow-hidden shadow-2xl">
            <img
              src="/services.webp"
              alt="Services"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-20">
          {services.map((service, index) => (
            <div
              key={index}
              className="group relative bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 border border-gray-100 overflow-hidden last:lg:col-span-2 last:lg:justify-self-center last:lg:max-w-3xl"
            >
              <div
                className="absolute inset-0 opacity-0 group-hover:opacity-5 transition-opacity duration-500"
                style={{
                  backgroundImage: "linear-gradient(135deg,#93C754,#7FB740)",
                }}
              ></div>
              <div className="relative z-10">
                <div className="-mx-8 -mt-8 mb-6 overflow-hidden rounded-t-2xl">
                  <div className="w-full aspect-[16/9]">
                    <img
                      src={service.image}
                      alt={service.title}
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  {service.title}
                </h3>
                <p className="text-gray-700 leading-relaxed text-lg">
                  {service.description}
                </p>
              </div>
              <div
                className="absolute bottom-0 left-0 right-0 h-1 opacity-0 group-hover:opacity-100 transition-opacity duration-500"
                style={{
                  backgroundImage: "linear-gradient(90deg,#93C754,#7FB740)",
                }}
              ></div>
            </div>
          ))}
        </div>
        <div
          className="relative text-white rounded-3xl p-12 shadow-2xl overflow-hidden"
          style={{
            background: "linear-gradient(90deg,#93C754,#7FB740,#5C8A24)",
          }}
        >
          <div className="absolute inset-0 bg-black/10"></div>
          <div className="relative z-10 text-center">
            <h3 className="text-3xl md:text-4xl font-bold mb-6">
              Ready to Collaborate?
            </h3>
            <p className="text-xl mb-8 max-w-3xl mx-auto opacity-90">
              We welcome partnerships with organizations, institutions, and
              communities across Europe and beyond. Let's work together to
              create sustainable solutions.
            </p>
            <Link
              to="/contact"
              className="group bg-white text-gray-900 px-10 py-4 rounded-full font-semibold hover:bg-gray-100 transition-all duration-300 transform hover:scale-105 shadow-xl inline-flex items-center space-x-3"
              style={{ boxShadow: "0 0 0 2px #7FB740 inset" }}
            >
              <span>Start Your Project</span>
              <ArrowRight
                size={20}
                className="group-hover:translate-x-1 transition-transform"
                style={{ color: "#7FB740" }}
              />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
